import { render } from "./SalePage.vue?vue&type=template&id=46056c2c"
import script from "./SalePage.vue?vue&type=script&lang=js"
export * from "./SalePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__